export default "__VITE_ASSET__DCZsHa0d__"